"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENGINEERING_ADMIN_ID = void 0;
exports.ENGINEERING_ADMIN_ID = '16fd038b-d21c-4164-bd71-1788c5d31cd1';
